// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__T8ubE","insightsList":"newBusinessInsightsMenu_insightsList__1z7YC","active":"newBusinessInsightsMenu_active__38QMT"};